<template>
  <div class="collect-item-layout">
    <div class="collect-item-tit">
      <slot name="title" />
      <i
        class="icon icon-show-hide iconfont"
        :class="isShow ? 'iconicon-test18' : 'iconicon-test19' "
        @click="showhide"
      />
    </div>
    <div
      v-show="isShow"
      class="collect-item-con"
    >
      <slot name="collect-item-con" />
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      isShow: true
    }
  },
  methods: {
    showhide () {
      this.isShow = !this.isShow
    }
  }
}
</script>

<style lang="scss" scoped>
.collect-item-layout {
  border-top: 1px solid #ebebeb;
  margin-top: 16px;
  padding-top: 8px;
  .collect-item-tit {
    height: 32px;
    line-height: 32px;
    // font-weight: 60px;
    // font-size: 18px;
    margin-bottom:32px;
    position: relative;
    .icon-show-hide {
      color: #d6d6d6;
      font-size: 16px;
      position: absolute;
      right: 0;
      top: 0px;
      cursor: pointer;
    }
  }
}
</style>
